import { Star } from 'lucide-react';
import React, { useState } from 'react';

function FreelancerProfile({ ProUserdata, ChangeTab }) {
  const getCompletionColor = (percentage) => {
    if (percentage >= 80) return 'from-green-400 to-emerald-500';
    if (percentage >= 60) return 'from-yellow-400 to-orange-500';
    return 'from-red-400 to-pink-500';
  };

  const getCompletionStatus = (percentage) => {
    if (percentage >= 80) return 'Excellent';
    if (percentage >= 60) return 'Good';
    return 'Good';
  };

  const [userStats] = useState({
    ProfileCompletion: 75, 
    Credits: 2500
  });

  return (
    <div className="mx-auto space-y-6 p-4">
      {/* Welcome Section */}
      <section className="bg-gradient-to-br from-blue-50 to-indigo-100 shadow-lg rounded-2xl p-8 border border-blue-100">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-xl">
                {ProUserdata?.fullName?.charAt(0) || 'U'}
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-800">Welcome back!</h3>
                <p className="text-gray-600">Manage your profile and settings</p>
              </div>
            </div>
            <div className="bg-white/80 backdrop-blur-sm border border-white/50 rounded-xl px-6 py-3 inline-block shadow-sm">
              <span className="text-blue-700 font-semibold text-lg">{ProUserdata?.fullName}</span>
            </div>
          </div>

          {/* Profile Completion */}
          <div className="text-center bg-white/80 backdrop-blur-sm border border-white/50 rounded-xl p-6 shadow-sm">
            <div className="flex items-center justify-center gap-2 mb-3">
              <Star className="w-5 h-5 text-yellow-500" />
              <p className="text-sm font-semibold text-gray-700">Profile Completion</p>
            </div>
            <div
              className={`w-20 h-20 mx-auto rounded-full bg-gradient-to-br ${getCompletionColor(
                userStats.ProfileCompletion
              )} flex items-center justify-center text-white text-xl font-bold shadow-lg`}
            >
              {userStats.ProfileCompletion}%
            </div>
            <p className="text-xs font-medium text-gray-600 mt-2">
              {getCompletionStatus(userStats.ProfileCompletion)}
            </p>
          </div>
        </div>
      </section>

      {/* Profile Information */}
      <section className="bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
        <h3 className="text-2xl font-bold text-gray-800 mb-8">Profile Information</h3>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <InfoItem label="Full Name" value={ProUserdata?.fullName} />
          <InfoItem label="Company Name" value={ProUserdata?.companyName} />
          <InfoItem label="Email Address" value={ProUserdata?.emailAddress} />
          <InfoItem label="Mobile Number" value={ProUserdata?.phoneNumber} />
          <InfoItem label="City" value={ProUserdata?.City} />
          <InfoItem label="Location" value={ProUserdata?.Location} />
          <InfoItem label="Address" value={ProUserdata?.address} />
          <InfoItem label="Qualifications" value={ProUserdata?.qualifications} />
          <InfoItem label="Years of Experience" value={`${ProUserdata?.yearsOfExperience} Years`} />
          <InfoItem label="Specializations" value={ProUserdata?.specializationsOfExpertise?.join(', ')} />
          <InfoItem label="Employers" value={ProUserdata?.employers} />
          <InfoItem label="Service Area" value={ProUserdata?.serviceArea} />
          <InfoItem label="Additional Notes" value={ProUserdata?.additionalNotes} />
        </div>

        {/* Images Section */}
        <div className="mt-10">
          <h3 className="text-xl font-bold text-gray-800 mb-6">Uploaded Documents</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {ProUserdata?.Portfolioupload && (
              <ImageCard label="Portfolio" src={ProUserdata.Portfolioupload} />
            )}
            {ProUserdata?.UploadID && (
              <ImageCard label="ID Proof" src={ProUserdata.UploadID} />
            )}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <button
            onClick={() => ChangeTab('Update Profile')}
            className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-md hover:shadow-lg font-medium"
          >
            Update Profile
          </button>
        </div>
      </section>
    </div>
  );
}

const InfoItem = ({ label, value }) => (
  <div className="group">
    <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
      {label}
    </label>
    <div className="px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-gray-800 font-medium">
      {value || '—'}
    </div>
  </div>
);

const ImageCard = ({ label, src }) => (
  <div className="space-y-2">
    <p className="text-sm font-semibold text-gray-600">{label}</p>
    <a href={src} target="_blank" rel="noopener noreferrer">
      <img
        src={src}
        alt={label}
        className="w-full h-48 object-cover rounded-xl border shadow-sm hover:shadow-lg transition-shadow"
      />
    </a>
  </div>
);

export default FreelancerProfile;
